import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { GroupPermission, PermissionLevelId, getToken } from "helpers";

type GetPermissionsByGroupArgs = {
  is_critical_operation?: boolean;
  is_default?: boolean;
  permission_level_id?: PermissionLevelId;
  include_default_permissions?: boolean;
};

// Define a service using a base URL and expected endpoints
export const permissionApi = createApi({
  reducerPath: "permissionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/auth/permission`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPermissionsByGroup: builder.query<GroupPermission[], GetPermissionsByGroupArgs>({
      query: ({ is_critical_operation, is_default, permission_level_id, include_default_permissions = true }) => ({
        url: "group-by-action/list",
        params: {
          is_critical_operation,
          is_default,
          permission_level_id: undefined,
          include_default_permissions,
        },
      }),
      transformResponse: (response: any) => response.data.groups,
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useGetPermissionsByGroupQuery,
  useLazyGetPermissionsByGroupQuery,
  usePrefetch: usePermissionApiPrefetch,
} = permissionApi;
